import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };

  open(event) {
    event.preventDefault();
    const url = event.currentTarget.dataset.cellDetailUrl;
    const modalBody = document.getElementById("cellDetailModalBody");
    const modal = document.getElementById("cellDetailModal");

    modalBody.innerHTML = '<div class="text-center p-4"><i class="fas fa-spinner fa-spin fa-2x"></i></div>';
    $(modal).modal("show");

    fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then((response) => response.text())
      .then((html) => {
        modalBody.innerHTML = html;
      })
      .catch(() => {
        modalBody.innerHTML =
          '<div class="alert alert-danger">Error al cargar los datos.</div>';
      });
  }
}
